import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const Item = styled(Box)``;
Item.displayName = "Group.Item";
const Group = styled(Box)`
    display: flex;
    flex-direction: ${({ direction }) => {
  switch (direction) {
    case "vertical":
      return "column";
    case "horizontal-reverse":
      return "row-reverse";
    case "vertical-reverse":
      return "column-reverse";
    default:
      return "row";
  }
}};
    margin: 0;

    > ${Item}:not(:last-child) {
        margin-right: ${({ gutter = "md", direction }) => direction === "horizontal" && spacing(gutter)};
        margin-bottom: ${({ gutter = "md", direction }) => direction === "vertical" && spacing(gutter)};
        margin-left: ${({ gutter = "md", direction }) => direction === "horizontal-reverse" && spacing(gutter)};
        margin-top: ${({ gutter = "md", direction }) => direction === "vertical-reverse" && spacing(gutter)};
    }
`;
const Styled = {
  Item,
  Group
};

export { Styled };
//# sourceMappingURL=styled.es.js.map
